import styles from "../styles/GetAppLanding.module.scss";
import investorCircle from "../assets/investor-circle.svg";
import investorNear from "../assets/investor-near.svg";
import investorQed from "../assets/investor-qed.png";
import investorToi from "../assets/investor-toi.png";

const investors = [
  {
    src: investorToi,
    alt: "The Times of India",
    className: styles.investorToi,
  },
  {
    src: investorQed,
    alt: "QED Investors",
    className: styles.investorQed,
  },
  {
    src: investorNear,
    alt: "Near Foundation",
    className: styles.investorNear,
  },
  {
    src: investorCircle,
    alt: "Circle",
    className: styles.investorCircle,
  },
];

const InvestorStrip = () => (
  <section
    className={styles.investorStrip}
    aria-label="Backed by leading investors"
  >
    <div className={styles.investorInner}>
      <p>
        Backed by <br className={styles.investorBreak} />
        leading investors
      </p>
      <div className={styles.investorLogos}>
        {investors.map((investor) => (
          <div className={styles.investorLogoSlot} key={investor.alt}>
            <img
              className={investor.className}
              src={investor.src}
              alt={investor.alt}
            />
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default InvestorStrip;
